import React from 'react';
import { Link } from 'react-router-dom';

import '../../home/home.css';

const Company = () => {

    return(
        <>
            <section className="insidePage" style={{ backgroundColor: '#2fb8e7' }}>
                <div className="container" data-aos="fade-up" data-aos-duration="500" data-aos-delay="0.9s">
                    <p className="text-white">
                        <span className='title text-center'>Company</span> 
                        <span className='text-center subTitle'>
                            Trusted by big one and loved by everyone
                        </span>
                    </p>            
                </div>
            </section>

            <main className="main">
                <section id="clients" className="clients">
                    <div className="container" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="0.9s">
                        <div className="row gy-4">
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/company/our-clients'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/ourClient.webp" alt="" />
                                    </div> 
                                    <h5>Our Clients</h5>
                                    <p>Find here, most frequently asked questions and answers...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/company/our-technology-partners'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/knowledgebased.webp" alt="" />
                                    </div> 
                                    <h5>Technology Partners</h5>
                                    <p>Find here, most frequently asked questions and answers...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/company/about-us'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-aboutus.webp" alt="" />
                                    </div> 
                                    <h5>About Us</h5>
                                    <p>Your one Stop Shop for all Digital, Web, Data Science and Software solutions...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/company/career'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-career.webp" alt="" />
                                    </div> 
                                    <h5>Career</h5>
                                    <p>Let’s solve some challenges together through technology...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/company/testimonials'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-testimonial.webp" alt="" />
                                    </div> 
                                    <h5>Testimonial</h5>
                                    <p>Let’s explore what our clients say about our solutions and service...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                {/* <Link to = '/company/faq'> */}
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-knowledged-base.webp" alt="" />
                                    </div> 
                                    <h5>FAQ</h5>
                                    <p>Find here, most frequently asked questions and answers...</p>
                                {/* </Link> */}
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                {/* <Link to = '/'> */}
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-our-team.webp" alt="" />
                                    </div> 
                                    <h5>Our Team</h5>
                                    <p>We hire people who are passionate about solving  problems through technology...</p>
                                {/* </Link> */}
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/company/blogs'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/menu/web_solution_firm-blog.webp" alt="" />
                                    </div> 
                                    <h5>Our Blog</h5>
                                    <p>At Tech Innovators Blog, we dive into the latest in technology, providing insightful articles...</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    ); 
}
export default Company;